import {
  Box,
  Flex,
  Image,
  Link,
  ListItem,
  Modal,
  ModalContent,
  ModalOverlay,
  Switch,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  UnorderedList,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import iconClose from "../../assets/images/projectManagement/icon-close.svg";
// import FormProjectManagementAdd from "../form/formProjectManagementAdd";
import { formatTablePopup } from "../../pages/projectManagement/formatTablePopup";
import Slider from "../slider";
import { projectManagerCall } from "../../api/projectManager";
import { useSelector } from "react-redux";
import { employeeCall } from "../../api/employee";
import { htmlToPlainPreview } from "../../utils/utils";
const REACT_APP_ROUTE_RATE =
  process.env.REACT_APP_ROUTE_RATE ||
  "MSH_RATE_PRODUCT_AND_APARTMENT_MANAGEMENT";
const PopupProjectManagementTitle = ({
  isOpen,
  onClose,
  defaultValue,
  idData,
}) => {
  const [data, setData] = useState(defaultValue);
  const [employeeManagers, setEmployeeManagers] = useState(null);
  const historyTableData = {
    headers: [
      {
        label: "Tên nhân viên",
        key: "name",
      },
      {
        label: "Chức danh",
        key: "position",
      },
      {
        label: "Hệ số thưởng",
        key: "commission",
      },
    ],
    data: data?.dataProjectManagers || employeeManagers || [],
  };
  const user = useSelector((state) => state.auth.login?.currentUser);
  const [getRoleUser, setGetRoleUser] = useState(false);

  const fetchDataUser = async (id) => {
    try {
      const res = await employeeCall.roleUser(id);
      if (res?.group_role_code) {
        const hasRole = res?.group_role_code
          ?.split(",")
          .includes(REACT_APP_ROUTE_RATE);
        setGetRoleUser(hasRole);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  let avatarItem = null;
  let honorItem = null;
  let otherItem = null;

  if (idData) {
    avatarItem = data?.images?.find((item) => item.type === "AVATAR");
    honorItem = data?.images?.find((item) => item.type === "HONOR");
    otherItem = data?.images?.filter((img) => img.type === "OTHER");
    if (honorItem) {
      data.imageHonor = honorItem;
    }
    if (avatarItem) {
      data.imageProject = avatarItem;
    }
    if (otherItem) {
      data.imageOther = otherItem;
    }
  }

  useEffect(() => {
    fetchDataUser(user?.user?._id);
  }, [user?.user?._id]);

  useEffect(() => {
    if (idData) {
      const fetchData = async () => {
        try {
          const projectManager = await projectManagerCall.getById(idData);
          if (projectManager) {
            setData(projectManager || []);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      const fetchProjectManager = async () => {
        try {
          const projectManager = await projectManagerCall.getManyPath([idData]);

          if (projectManager[0]) {
            let dataProjectManagers = projectManager[0].map((item) => ({
              name: item?.manager?.fullName || "",
              position: item?.manager?.jobPosition?.name || "",
              commission: item?.commission.toString() || "",
            }));

            setEmployeeManagers(dataProjectManagers);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      fetchProjectManager();
      fetchData();
    }

    if (defaultValue) {
      setData(defaultValue);
    }
  }, [idData, defaultValue]);

  let dataMap = [];

  if (data?.fileProject) {
    dataMap = data?.fileProject?.map((item) => ({
      name: item?.name,
      path: item?.path,
    }));
  }

  if (data?.documents) {
    dataMap = data?.documents?.map((item) => ({
      name: item?.name,
      path: item?.path,
    }));
  }

  const fileData = {
    headers: [
      {
        label: "Tên file",
        key: "name",
      },
      {
        label: "Tải xuống",
        key: "download",
      },
    ],
    data: dataMap || [],
  };

  const slideImage = [];
  if (data?.imageHonor?.path) {
    slideImage.push(data?.imageHonor?.path);
  }

  if (data?.imageProject?.path) {
    slideImage.push(data?.imageProject?.path);
  }

  if (data?.imageOther) {
    data.imageOther.forEach((item) => {
      if (item?.path) {
        slideImage.push(item.path);
      }
    });
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        borderRadius={"16px"}
        maxW={"1210px"}
        maxH={"88vh"}
        overflow="auto"
      >
        <Flex
          borderBottom={"1px solid var(--color-boder)"}
          alignItems={"center"}
          justifyContent={"space-between"}
          p={"24px 20px 24px 24px"}
        >
          <Text fontSize={"18px"} fontWeight={600} lineHeight={"normal"}>
            Chi tiết dự án
          </Text>
          <Image src={iconClose} onClick={onClose} cursor={"pointer"} />
        </Flex>
        <Box p={"24px 40px 107px 40px"}>
          <Flex gap={"40px"}>
            <Flex w={"50%"} flexDirection={"column"} gap={{ base: "24px" }}>
              <Flex flexDirection={"column"} gap={"8px"}>
                <Text
                  fontSize={"20px"}
                  fontWeight={600}
                  lineHeight={"140%"}
                  textTransform={"uppercase"}
                  color="var(--color-black)"
                >
                  {data?.name || ""}
                </Text>
                <Text
                  color="var(--color-black)"
                  fontSize={"14px"}
                  fontWeight={500}
                  lineHeight={"140%"}
                  textTransform={"capitalize"}
                >
                  {data?.address || ""}
                </Text>
              </Flex>
              <Flex flexDirection={"column"} gap={"16px"}>
                <Text
                  fontSize={"16px"}
                  fontWeight={600}
                  lineHeight={"normal"}
                  color="var(--color-black)"
                >
                  Đặc điểm dự án
                </Text>
                {/* <Flex alignItems={"center"} gap={{ base: "27px" }}>
                  <Box flex={1}>
                    <Text
                      fontSize={"12px"}
                      lineHeight={"15px"}
                      color={"var(--color-label-employee)"}
                    >
                      Hệ số K
                    </Text>
                    <Text
                      mt={"8px"}
                      fontSize={"14px"}
                      lineHeight={"17px"}
                      fontWeight={500}
                      color={"var(--color-info-employee)"}
                    >
                      {data?.kRate || ""}
                    </Text>
                  </Box>
                </Flex> */}
                <Flex alignItems={"center"} gap={{ base: "27px" }}>
                  <Box flex={1}>
                    <Text
                      fontSize={"12px"}
                      lineHeight={"15px"}
                      color={"var(--color-label-employee)"}
                    >
                      Loại hình dự án
                    </Text>
                    <Text
                      mt={"8px"}
                      fontSize={"14px"}
                      lineHeight={"17px"}
                      fontWeight={500}
                      color={"var(--color-info-employee)"}
                    >
                      {data?.projectType?.name || ""}
                    </Text>
                  </Box>
                  <Box flex={1}>
                    <Text
                      fontSize={"12px"}
                      lineHeight={"15px"}
                      color={"var(--color-label-employee)"}
                    >
                      Thành phố
                    </Text>
                    <Text
                      mt={"8px"}
                      fontSize={"14px"}
                      lineHeight={"17px"}
                      fontWeight={500}
                      color={"var(--color-info-employee)"}
                    >
                      {data?.city?.name || ""}
                    </Text>
                  </Box>
                </Flex>
                <Flex alignItems={"center"} gap={{ base: "27px" }}>
                  <Box flex={1}>
                    <Text
                      fontSize={"12px"}
                      lineHeight={"15px"}
                      color={"var(--color-label-employee)"}
                    >
                      Chủ đầu tư
                    </Text>
                    <Text
                      mt={"8px"}
                      fontSize={"14px"}
                      lineHeight={"17px"}
                      fontWeight={500}
                      color={"var(--color-info-employee)"}
                    >
                      {data?.investor?.name || ""}
                    </Text>
                  </Box>
                </Flex>
                <Flex mt={"16px"}>
                  <Box>
                    <Text
                      lineHeight={"15px"}
                      m="0"
                      fontSize={{ base: "12px" }}
                      mb={"6px"}
                      fontWeight={400}
                      color={"var(--color-label-employee)"}
                    >
                      Cho phép lên TTKQ/VBTT/HĐTHNV
                    </Text>
                    <Switch
                      readOnly={true}
                      isChecked={data?.is_allow_ttkq || false}
                    />
                  </Box>
                </Flex>
                <Flex mt={"16px"} w={"100%"} gap={"27px"}>
                  <Box flex={1}>
                    <Text
                      fontSize={"12px"}
                      lineHeight={"15px"}
                      color={"var(--color-label-employee)"}
                    >
                      Loại đại lý
                    </Text>
                    <Text
                      mt={"8px"}
                      fontSize={"14px"}
                      lineHeight={"17px"}
                      fontWeight={500}
                      color={"var(--color-info-employee)"}
                    >
                      {data?.agent || ""}
                    </Text>
                  </Box>
                  <Box flex={1}>
                    <Text
                      fontSize={"12px"}
                      lineHeight={"15px"}
                      color={"var(--color-label-employee)"}
                    >
                      Thời gian tiếp nhận
                    </Text>
                    <Text
                      mt={"8px"}
                      fontSize={"14px"}
                      lineHeight={"17px"}
                      fontWeight={500}
                      color={"var(--color-info-employee)"}
                    >
                      {data?.received || ""}
                    </Text>
                  </Box>
                </Flex>
                {getRoleUser && (
                  <>
                    <Flex mt={"16px"} w={"100%"} gap={"27px"}>
                      <Box flex={1}>
                        <Text
                          fontSize={"12px"}
                          lineHeight={"15px"}
                          color={"var(--color-label-employee)"}
                        >
                          % phí dịch vụ nhận từ CĐT (X)
                        </Text>
                        <Text
                          mt={"8px"}
                          fontSize={"14px"}
                          lineHeight={"17px"}
                          fontWeight={500}
                          color={"var(--color-info-employee)"}
                        >
                          {data?.commissionFromInvestor || "-"}
                        </Text>
                      </Box>
                      <Box flex={1}>
                        <Text
                          fontSize={"12px"}
                          lineHeight={"15px"}
                          color={"var(--color-label-employee)"}
                        >
                          % phí dịch vụ trả cho sale (Y)
                        </Text>
                        <Text
                          mt={"8px"}
                          fontSize={"14px"}
                          lineHeight={"17px"}
                          fontWeight={500}
                          color={"var(--color-info-employee)"}
                        >
                          {data?.commissionToSales || "-"}
                        </Text>
                      </Box>
                    </Flex>

                    <Flex mt={"16px"} w={"100%"} gap={"27px"}>
                      <Box flex={1}>
                        <Text
                          fontSize={"12px"}
                          lineHeight={"15px"}
                          color={"var(--color-label-employee)"}
                        >
                          % phí dịch vụ nhận từ đối tác ngoài CĐT (Z)
                        </Text>
                        <Text
                          mt={"8px"}
                          fontSize={"14px"}
                          lineHeight={"17px"}
                          fontWeight={500}
                          color={"var(--color-info-employee)"}
                        >
                          {data?.commissionFromPartner || "-"}
                        </Text>
                      </Box>
                    </Flex>
                  </>
                )}
              </Flex>

              <Flex flexDirection={"column"} gap={"16px"}>
                <Flex alignItems={"center"} justifyContent={"space-between"}>
                  <Text
                    fontSize={"16px"}
                    fontWeight={600}
                    lineHeight={"normal"}
                    color="var(--color-black)"
                  >
                    Tài liệu dự án
                  </Text>
                </Flex>
                <Flex
                  border={"1px solid var(--color-boder)"}
                  borderRadius={"8px"}
                >
                  <TableContainer w={"100%"} pb={"32px"}>
                    <Table w={"100%"} variant="unstyled">
                      <Thead
                        fontSize={"12px"}
                        w={"100%"}
                        color="var(--color-black-label)"
                        fontWeight="400"
                        borderBottom={"1px solid var(--color-boder)"}
                      >
                        <Tr bg={"var(--fill-avatar)"}>
                          {fileData.headers.map((e, index) => {
                            let width = "auto";
                            let textAlign = "auto";
                            if (e.key === "name") {
                              width = "80%";
                              textAlign = "start";
                            } else if (e.key === "commission") {
                              width = "20%";
                              textAlign = "start";
                            }
                            return (
                              <Td
                                p={"12px 12px 8px 16px"}
                                key={index}
                                border={"none"}
                                color={"#51607B"}
                                fontSize={{ base: "14px" }}
                                w={width}
                              >
                                <Box textAlign={"center"} fontWeight={"bold"}>{e.label}</Box>
                              </Td>
                            );
                          })}
                        </Tr>
                      </Thead>
                      <Tbody w={"100%"} h={"100%"}>
                        {fileData.data?.length > 0 ? (
                          fileData.data?.map((e, rowIndex) => {
                            const keyValues = Object.keys(e);
                            return (
                              <Tr
                                w={"100%"}
                                key={rowIndex}
                                h={"44px"}
                                backgroundColor={
                                  rowIndex % 2 === 0
                                    ? "#transparent"
                                    : "var(--fill-avatar)"
                                }
                              >
                                {keyValues.map((keyvalue, index) => {
                                  return (
                                    <Td p={"12px 10px 12px 16px"} key={index}>
                                      <Box
                                        fontSize={{ base: "14px" }}
                                        fontWeight={500}
                                        color="var(--color-black)"
                                        h={"140%"}
                                        textAlign={"center"}
                                      >
                                        {formatTablePopup(
                                          e[keyvalue],
                                          keyvalue,
                                        )}
                                      </Box>
                                    </Td>
                                  );
                                })}
                              </Tr>
                            );
                          })
                        ) : (
                          <Tr>
                            <Td
                              colSpan={fileData.headers.length}
                              textAlign="center"
                              padding={"40px 0"}
                            >
                              Không có dữ liệu
                            </Td>
                          </Tr>
                        )}
                      </Tbody>
                    </Table>
                  </TableContainer>
                </Flex>
              </Flex>

              <Flex flexDirection={"column"} gap={"16px"}>
                <Flex alignItems={"center"} justifyContent={"space-between"}>
                  <Text
                    fontSize={"16px"}
                    fontWeight={600}
                    lineHeight={"normal"}
                    color="var(--color-black)"
                  >
                    Nhân viên quản lý
                  </Text>
                </Flex>
                <Flex
                  border={"1px solid var(--color-boder)"}
                  borderRadius={"8px"}
                >
                  <TableContainer w={"100%"} pb={"32px"}>
                    <Table w={"100%"} variant="unstyled">
                      <Thead
                        fontSize={"12px"}
                        w={"100%"}
                        color="var(--color-black-label)"
                        fontWeight="400"
                        borderBottom={"1px solid var(--color-boder)"}
                      >
                        <Tr bg={"var(--fill-avatar)"}>
                          {historyTableData.headers.map((e, index) => {
                            let width = "auto";
                            let textAlign = "auto";
                            if (e.key === "name") {
                              width = "40%";
                              textAlign = "start";
                            } else if (e.key === "position") {
                              width = "20%";
                              textAlign = "start";
                            } else if (e.key === "commission") {
                              width = "20%";
                              textAlign = "start";
                            }
                            return (
                              <Td
                                p={"12px 12px 8px 16px"}
                                key={index}
                                border={"none"}
                                color={"#51607B"}
                                fontSize={{ base: "14px" }}
                                w={width}
                              >
                                <Box textAlign={"center"} fontWeight={"bold"}>{e.label}</Box>
                              </Td>
                            );
                          })}
                        </Tr>
                      </Thead>
                      <Tbody w={"100%"} h={"100%"}>
                        {historyTableData.data?.length > 0 ? (
                          historyTableData.data?.map((e, rowIndex) => {
                            const keyValues = Object.keys(e);
                            return (
                              <Tr
                                w={"100%"}
                                key={rowIndex}
                                h={"44px"}
                                backgroundColor={
                                  rowIndex % 2 === 0
                                    ? "#transparent"
                                    : "var(--fill-avatar)"
                                }
                              >
                                {keyValues.map((keyvalue, index) => {
                                  return (
                                    <Td p={"12px 10px 12px 16px"} key={index}>
                                      <Box
                                        fontSize={{ base: "14px" }}
                                        fontWeight={500}
                                        color="var(--color-black)"
                                        h={"140%"}
                                      >
                                        {formatTablePopup(
                                          e[keyvalue],
                                          keyvalue,
                                        )}
                                      </Box>
                                    </Td>
                                  );
                                })}
                              </Tr>
                            );
                          })
                        ) : (
                          <Tr>
                            <Td
                              colSpan={historyTableData.headers.length}
                              textAlign="center"
                              padding={"40px 0"}
                            >
                              Không có dữ liệu
                            </Td>
                          </Tr>
                        )}
                      </Tbody>
                    </Table>
                  </TableContainer>
                </Flex>
              </Flex>
            </Flex>
            <Flex w={"50%"} flexDirection={"column"} gap={"24px"}>
              <Flex flexDirection={"column"} gap={"8px"}>
                <Text fontSize={"16px"} fontWeight={600}>
                  Ảnh dự án
                </Text>
                <Slider slideDatas={slideImage} />
              </Flex>

              <Flex flexDirection={"column"} gap={"8px"}>
                <Text
                  fontSize={"16px"}
                  fontWeight={600}
                  lineHeight={"normal"}
                  color="var(--color-black)"
                >
                  Mô tả dự án
                </Text>
                <UnorderedList
                  m={0}
                  listStyleType="none"
                  fontSize={"14px"}
                  fontWeight={400}
                  lineHeight={"140%"}
                  textTransform={"capitalize"}
                  color="var(--color-black)"
                >
                  <ListItem whiteSpace="pre-line" wordBreak="break-word">
                    {htmlToPlainPreview(data?.description || "")}
                  </ListItem>
                </UnorderedList>
              </Flex>
            </Flex>
          </Flex>
        </Box>
      </ModalContent>
    </Modal>
  );
};

export default PopupProjectManagementTitle;
